import apiClient from "../api";

export const getModelsData = async (storeId, page, limit) => {
    try {
        const response = await apiClient.get(`gestock/models/all/${storeId}?page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};
